var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"dust-container"},_vm._l((_vm.framesLength),function(frame){return _c('canvas',{key:frame,class:{
      'dust': _vm.showDust
    },attrs:{"width":"450","height":"520"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }